import { render, staticRenderFns } from "./BannerFormCreate.vue?vue&type=template&id=54693f81&"
import script from "./BannerFormCreate.vue?vue&type=script&lang=js&"
export * from "./BannerFormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports